import { PERMISSION_ENTITY_INVOICE_OFFER } from '@klear/constants'
import type { Fee } from '@klear/fee'
import type { Money } from '@klear/money'
import {
  domainListItemId,
  domainListItemParentId,
  type OrderEventDomainListItem
} from '@klear/order-event/order-event-domain-list'

export type OrderEventFeeCollection = {
  paymentId: number
  effectiveDate: string | null
  amount: Money
  status: string | null
}

type TimelineChildren = { children: OrderEventTimelineItem[] }

export type OrderEventTimelineItem =
  | (Exclude<OrderEventDomainListItem, { type: typeof PERMISSION_ENTITY_INVOICE_OFFER }> & TimelineChildren)
  | (Extract<OrderEventDomainListItem, { type: typeof PERMISSION_ENTITY_INVOICE_OFFER }> & {
      fees: Fee[]
      feeCollections: OrderEventFeeCollection[]
    } & TimelineChildren)

export function timelineItemId(item: OrderEventTimelineItem): number {
  return domainListItemId(item)
}

export function timelineItemParentId(item: OrderEventTimelineItem): number | undefined {
  return domainListItemParentId(item)
}

export function nestTimelineItems(items: OrderEventTimelineItem[]): OrderEventTimelineItem[] {
  const byId = new Map<number, OrderEventTimelineItem>()
  for (const item of items) byId.set(timelineItemId(item), item)
  const roots: OrderEventTimelineItem[] = []
  for (const item of items) {
    const parentId = timelineItemParentId(item)
    const parent = parentId != null ? byId.get(parentId) : undefined
    if (parent && parent !== item) parent.children.push(item)
    else roots.push(item)
  }
  return roots
}
